module.exports = __webpack_public_path__ + "static/media/kz.c70a8bdc.svg";